import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';

const Loading = ( { loading = false, fontSize = 'inherit', color='inherit', ...props } ) => (
    loading && <CircularProgress fontSize={fontSize} color={color} {...props} />
);

export default Loading;
